module.exports = __webpack_public_path__ + "img/ic_video_record.a97f9d4a.png";